import React from "react";

const SummaryRow = ({ label, currency = "Rp", value }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "200px 50px 80px",
        marginBottom: "6px",
      }}
    >
      <span>{label}</span>
      <span>{currency}</span>
      <span style={{ textAlign: "right" }}>{value}</span>
    </div>
  );
};

export default SummaryRow;
